import { LocalItem } from '~Types';
import { Item } from '@baemingo/inventory-events/dist/types';

type CheckOutOfStock = {
  id: string;
  inventoryItems: Item[];
  disregardCount: boolean;
  cartItems?: LocalItem[];
  isCart?: boolean;
};

export const checkOutOfStock = ({
  id,
  inventoryItems,
  cartItems,
  disregardCount,
  isCart,
}: CheckOutOfStock) => {
  const inventoryItem = inventoryItems.find((item) => item.itemId === id);

  if (disregardCount) {
    return inventoryItem ? inventoryItem.outOfStock : false;
  }

  if (inventoryItem?.outOfStock) {
    return true;
  }

  // If the user has added all available items to the cart
  if (typeof inventoryItem?.count === 'number' && cartItems) {
    const itemCartQuantity = cartItems.filter((item) => item.itemId === id).length;
    const count = inventoryItem.count - itemCartQuantity;

    if ((isCart && count < 0) || (!isCart && count === 0)) {
      return true;
    }
  }

  return false;
};
